import { IMdCmSearchFields } from '../types/FmsTypes'
import { MdEnableStatusEnum } from '../types/FmsEnums'

//系统标识
export const CLIENT_APP_CODE = 'fms'

export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_FIRST_PAGE_NUM = 1
export const DEFAULT_REQUEST_TIMEOUT = 10000
export const LONG_REQUEST_TIMEOUT = 6000000

//财务的请求环境
const baseRequestUrl = {
    DEV: `http://api.peijian88.cn/fms`,
    // TEST: `https://test-api-2.laoniuche.cn/fms`,
    TEST: `https://test-api-2.laoniuche.cn/fms`,
    PROD: 'https://tam-api.yunhaogroup.com/fms',
    STAGE: 'http://api.beiben88.com/fms',
}

// 业务系统单据的请求环境
const baseRequestUrl1 = {
    DEV: `http://api.peijian88.cn`,
    // TEST: `https://test-api-2.laoniuche.cn`,
    TEST: `https://test-api-2.laoniuche.cn`,
    PROD: 'https://tam-api.yunhaogroup.com',
    STAGE: 'http://api.beiben88.com',
}

//云创接口地址
const ciRequestUrl = {
    DEV: `https://test.tam-api.yunhaochefu.com`,
    TEST: `https://test.tam-api.yunhaochefu.com`,
    PROD: 'https://tam-api.yunhaochefu.com',
}

const baseWSRequestUrl = {
    DEV: `ws://api.peijian88.cn/fms`,
    // TEST: `ws://test-api.laoniuche.cn/fms`,
    // TEST: `ws://api-2.laoniuche.cn/fms`,
    TEST: `ws://192.168.110.121:8089/fms`,
    // PROD: 'wss://tam-api.yunhaogroup.com/fms',
    PROD: 'ws://fms.websocket.yunhaogroup.com/fms',
    // STAGE: 'ws://api.beiben88/fms',
}
//鉴权的请求环境
const baseAuthRequestUrl = {
    DEV: `http://api.peijian88.cn/auth`,
    TEST: `https://test-api-2.laoniuche.cn/auth`,
    PROD: 'https://api.yunhaogroup.com/auth',
    STAGE: 'http://api.beiben88/auth',
}

//鉴权2的请求环境
const baseAuth2RequestUrl = {
    DEV: `http://api.peijian88.cn`,
    // TEST: `https://test-api-2.laoniuche.cn`,
    TEST: `https://test-api-2.laoniuche.cn`,
    PROD: 'https://tam-api.yunhaogroup.com',
    STAGE: 'http://api.beiben88',
}

//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    return `${getBaseRequestUrl1()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${getBaseRequestUrl1()}/fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片查看地址
export const getCiImgLookUrl = (md5: string) => {
    return `https://file-server.yunhaochefu.com/image/${md5}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseRequestUrl[REACT_APP_ENV ?? 'DEV']
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl1 = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseRequestUrl1[REACT_APP_ENV ?? 'DEV']
}

//根据环境变量自动获取请求地址
export const getCiRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return ciRequestUrl[REACT_APP_ENV ?? 'DEV']
}

export const getBaseWSRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseWSRequestUrl[REACT_APP_ENV ?? 'DEV']
}

//获取生产地址(因发票识别需要使用https,所以发票图片上传使用生产地址)
export const getProdBaseRequestUrl = () => {
    return baseRequestUrl1['PROD']
}

export const getBaseAuthRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseAuthRequestUrl[REACT_APP_ENV ?? 'DEV']
}

//根据环境变量自动获取鉴权请求地址
export const getBaseAuth2RequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseAuth2RequestUrl[REACT_APP_ENV ?? 'DEV']
}

//服务器自定义错误码serve
export const INTERNAL_SERVER_ERROR_CODE = 500
export const INTERNAL_SERVER_LOGON_FAILURE_CODE = 401
//token存储KEY值
export const TOKEN_KEY = 'token'
//获取token
export const getToken = () => {
    return sessionStorage.getItem(TOKEN_KEY) ?? 'default-token-str'
}
//存储token
export const setToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token)
}

//主数据通用字段定义
export const defaultMdCmParam: IMdCmSearchFields = {
    sourceApp: CLIENT_APP_CODE,
    sourceAuthKey: '',
    // branch: "fms",
    // branchList: ["main", "fms"],
    ver: undefined,
    // enable: MdEnableStatusEnum.ENABLE,
}

export const branchDs = [
    { label: '财务分支', value: 'fms' },
    { label: '主分支', value: 'main' },
]
